import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import PropTypes from 'prop-types';

export const UnitNavLink = ({
  unit,
  handleRemoveUnit,
  setActiveUnit,
  index,
  activeUnitIndex
}) => {
  return (
    <Nav.Link
      eventKey={index}
      key={index}
      className="chat-contact p-3"
      onClick={() => setActiveUnit(index)}
      ref={ref => {
        if (index === activeUnitIndex) ref?.click();
      }}
    >
      <Flex>
        <Avatar
          name={`${index + 1}`.split('').join(' ')}
          size="xl"
          mediaClass="bg-300 text-dark fs--1"
        />

        <div
          className="flex-1 chat-contact-body ms-2 d-flex align-items-center justify-content-between gap-2 opacity-lg-100 ms-lg-2 opacity-md-0 w-md-0 ms-md-0"
          style={{
            transition: 'all 0.3s ease-in'
          }}
        >
          <h6 className="mb-0 fs-0 chat-contact-title">
            {unit.name || `Unidad ${index + 1}`}
          </h6>

          <FontAwesomeIcon
            icon="trash"
            className="text-danger cursor-pointer fs--1"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              handleRemoveUnit(index);
            }}
          />
        </div>
      </Flex>
    </Nav.Link>
  );
};

UnitNavLink.propTypes = {
  unit: PropTypes.object.isRequired,
  handleRemoveUnit: PropTypes.func.isRequired,
  setActiveUnit: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  activeUnitIndex: PropTypes.number.isRequired
};
